import React from 'react';
import PageControls from './PageControls';
import { Header } from './PageHeader.styles';
import { useGeneralLedger } from 'general-ledger/fast-gl/hooks/useGeneralLedger';
import { DateRange, GeneralLedgerFilters } from '../../types';

type PageHeaderProps = {
  updateQueryParams: (params: Record<string, string>) => void;
  onSearchUpdate?: (search?: string) => void;
};

const PageHeader = ({ updateQueryParams, onSearchUpdate }: PageHeaderProps): React.ReactElement => {
  const {
    dateRange,
    showAccounts,
    showQualityIssues,
    search,
    updateDateRange,
    updateInternalFilters,
  } = useGeneralLedger();

  const setNewDateRange = (newDateRange: DateRange) => {
    updateDateRange && updateDateRange(newDateRange);
    updateQueryParams({ ...newDateRange });
  };

  const updateFilters = (filters: GeneralLedgerFilters) => {
    updateInternalFilters && updateInternalFilters(filters);
    if (filters.showAccounts !== undefined) {
      updateQueryParams({ showAccounts: filters.showAccounts.toString() });
    } else if (filters.showQualityIssues !== undefined) {
      updateQueryParams({ showQualityIssues: filters.showQualityIssues.toString() });
    } else if (filters.search !== undefined) {
      updateQueryParams({ search: filters.search });
      onSearchUpdate && onSearchUpdate(filters.search);
    }
  };

  return (
    <Header>
      <PageControls
        dateRange={dateRange}
        filters={{
          showAccounts,
          showQualityIssues,
          search,
        }}
        updateDateRange={setNewDateRange}
        updateFilters={updateFilters}
      />
    </Header>
  );
};

export default React.memo(PageHeader);
